import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { _PriceList } from "../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { PriceListItem } from "./PriceListItem";
import { CurrencyEditor } from "../../erp/cellEditor/Currency/CurrencyEditor";
import { ProductValueTypeConstantsSelect } from "../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/ProductValueTypeConstantsSelect";
import usePaginator from "../../theme/Component/usePaginator";
import { BasicButton } from "../../theme/Component/BasicButton";
import { InputDate } from "../../theme/Input/InputDate";



export const PriceList = () => {

    const PriceList = useDataBean(_PriceList);
    const single = Singleton.getInstance();
    const [Year, setYear] = useState<number>(null)
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const [lista, setLista] = useState<any>([]);
    const [isActive, setisActive] = useState<any>(null)
    const [modallista, setModallista] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        PriceList.instance.getPriceListCatalog(Year, regexStr, isActive, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    // setLista(resp.List)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Money = (user.DataBeanProperties.CurrencyCode ?? "") + "Sin Moneda" + (user.DataBeanProperties.CurrencyName ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }

    const create = () => {
        PriceList.setBean({
            Year: _single.getCurrenYear(),
            ProductValueType: 11,
        });
        setModal({ ...modal, "view": true, name: "Agregar lista de Precios" });
    }
    const deleteItem = () => {
        PriceList.deleteItemVoid(PriceList.bean.IDPriceList).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        PriceList.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDPriceList', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Desde', property: 'FromDate', visible: true },
        { title: 'Hasta', property: 'UptoDate', visible: true },
        { title: 'Activo', property: 'IsActive', visible: true },
        { title: 'Creado', property: 'Since', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Lista de Precios', icono: 'ri-list-check', visible: single.canEdit(), evento: () => { setModallista({ ...modallista, "name": `Lista de Precios de ${PriceList.bean.Name}`, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${PriceList.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Lista de Precios">
            <div className="row">
                <div className="col-md-6">
                    <YearSelector tittle="Año" value={Year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicSwitch estado={isActive} label="Activo ?" eventChange={(e: any) => { setisActive(e) }}></BasicSwitch>
                </div>
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={PriceList.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            {/* <div className="col-md-12">
                              <YearSelector tittle="Año" value={PriceList.bean.Year} onChange={(e) => { PriceList.setBean({ ...PriceList.bean, "Year": e }) }} />
                           </div> */}
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={PriceList.bean.Name} onChange={PriceList.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>

                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={PriceList.bean.Code} onChange={PriceList.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="FromDate" label="Desde" value={PriceList.bean.FromDate} setDate={(e: any) => { PriceList.setBean({ ...PriceList.bean, "FromDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="UptoDate" label="Hasta" value={PriceList.bean.UptoDate} setDate={(e: any) => { PriceList.setBean({ ...PriceList.bean, "UptoDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch estado={PriceList.bean.IsActive} label="Activo ?" eventChange={(e: any) => {
                                    PriceList.setBean({ ...PriceList.bean, "IsActive": e })
                                }}></BasicSwitch>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modallista} updateModal={setModallista}>
                        <div className="row">
                            <PriceListItem IDPriceList={PriceList.bean.IDPriceList} />

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {PriceList.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}